module.exports = __webpack_public_path__ + "img/33.7e7a14d7.svg";